"use client";

import React from "react";
import { Users, Heart, Scale, Handshake, Leaf, ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  icon: Users,
  title: "Gestión de la Responsabilidad Social",
  color: "bg-secondary"
}, {
  icon: Heart,
  title: "Calidad de vida en la empresa",
  color: "bg-accent"
}, {
  icon: Scale,
  title: "Ética empresarial",
  color: "bg-pink-600"
}, {
  icon: Handshake,
  title: "Vinculación con la comunidad",
  color: "bg-sky-500"
}, {
  icon: Leaf,
  title: "Vinculación con el medio ambiente",
  color: "bg-primary"
}];
export default function CompromisoAmbiental() {
  const {
    ref: topRef,
    isVisible: isTopVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: bottomRef,
    isVisible: isBottomVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257564" id="compromiso-ambiental" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="page-container">
        {}
        <div ref={topRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 items-center mb-20 transition-all duration-700 ease-out ${isTopVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-4 flex justify-center lg:justify-start">
            <div className="w-full max-w-[320px]">
              <AspectRatio ratio={3 / 2}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/esr_logo_distintivo.png" alt="Empresa Socialmente Responsable Logo" className="w-full h-full object-contain" loading="lazy" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/esr_logo_distintivo.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/esr_logo_distintivo.png-wvc-sizes" />
              </AspectRatio>
            </div>
          </div>
          
          <div className="lg:col-span-8 flex flex-col gap-6">
            <div className="flex flex-col gap-4">
              <Badge variant="outline" className="w-fit border-primary text-primary font-default">Distintivo ESR</Badge>
              <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground leading-tight">
                Nuestro Compromiso con la Responsabilidad Social
              </h2>
              <p className="text-lg text-muted-foreground font-default leading-relaxed">
                En el año 2021 nos consolidamos como Empresa Socialmente Responsable. Obtener este distintivo nos reta a continuar mejorando y gestionando la responsabilidad social en nuestra organización, enfocando nuestras acciones para impactar de manera positiva en nuestra comunidad, colaboradores y medio ambiente. Creemos firmemente que debemos buscar un equilibrio sostenible a través de un comportamiento ético con base en los valores de <span className="font-bold text-foreground">Kalisch Acero</span>.
              </p>
            </div>
            <div>
              <Button size="lg" asChild className="bg-primary hover:bg-primary-600 text-primary-foreground">
                <Link to="/NosotrosPage">
                  Conoce Nuestro Impacto
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div ref={bottomRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 transition-all duration-700 delay-200 ease-out ${isBottomVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {pillars.map((pillar, index) => <div key={index} data-index={index} className={`${pillar.color} p-8 flex flex-col items-center text-center gap-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-1 group`}>
              <div className="text-white transition-transform duration-300 group-hover:scale-110">
                <pillar.icon className="w-16 h-16 stroke-[1.5px]" />
              </div>
              <h3 className="text-white font-bold text-lg leading-snug font-default">
                {pillar.title}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}